import { Validators } from '@angular/forms';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { UNITS } from '@ordersnproducts/modules/shared/constants/units';
import { FormInfoMessageComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-info-message/form-info-message.component';
import { FormInputCheckboxComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-checkbox/form-input-checkbox.component';
import { FormInputNumberComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input-number/form-input-number.component';
import {
  FieldConfig,
  NewLineField,
} from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';
import { FieldLabelConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { FormSelectComponent } from '../../../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '../../../../../../../shared/modules/configurable-form/components/form-select/models/field-select-config.interface';
import { RmsFormConfig } from '../../../../models/rms-form-config';
import { PumpAvailability } from '../../../../providers/pump-availabe.provider';
import { CutOffEffects } from '../../../../effects/cut-off.effects';
import { FormInfoIconMessageComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-info-icon-message/form-info-icon-message.component';
import {
  FilteredUnloadTimesLoaderService,
  SingleApplicationsLoaderService,
  SingleSpacingsLoaderUkService,
  SingleUnloadTypesLoaderService,
} from '../../../../services/config-loader/loaders/single-catalogs.loader.service';
// product form field
import { MixReferencesOptionsLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/products.loader.service';
import { ProductsOpenPlatformEffects } from '@ordersnproducts/modules/order-builder/modules/rms-specification/effects/open-platform/products.effects';
import { ProductsDisablerOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/product-enabler.provider';
import { LoadContractMixReferenceService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/load-contract.command.service';
// contract form field
import { ContractsOptionLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/contract.loader.service';
// payment term form field
import { LoadSingleCatalogsUnloadTypeMixRef } from '../../../../services/config-loader/commands/single-catalogs-unload-type.command.service';
import { LoadSingleCatalogsSpacingMixRef } from '../../../../services/config-loader/commands/single-catalogs-spacing.command.service';
import { LoadSingleCatalogsLoadSizeMixRef } from '../../../../services/config-loader/commands/single-catalogs-load-size.command.service';
import { CapacityProvider } from '../../../../providers/rms-maximum-capacity.provider';
import { QuantityErrorOpenPlatformProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/quantity-error.provider';
import { LoadPaymentTermOpenPlatformCommandService } from '../../../../services/config-loader/commands/open-platform/load-payment-term.command.service';
import { PaymentTermsContractOptionLoaderOpenPlatformService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/loaders/open-platform/payment-term-contract-loader.service';
import { SingleCatalogsEffects } from '../../../../effects/single-catalogs.effects';
import { LoadSingleCatalogsApplicationMixRef } from '../../../../services/config-loader/commands/single-catalogs-application.command.service';
import { FormInputComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-input/form-input.component';
import { SetUnloadTimeChangeCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-unloadTime-change.command';
import { ResetSlotOpenPlatformCommandService } from '@ordersnproducts/modules/order-builder/modules/rms-specification/services/config-loader/commands/open-platform/reset-slot.command.service';
import { DateTimeEnablerProvider } from '@ordersnproducts/modules/order-builder/modules/rms-specification/providers/open-platform/date-time-enabler.provider';
import { SpecFieldTestIds } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-test-ids.enum';
import { LoadSingleCatalogsUnloadTimeMixRef } from '../../../../services/config-loader/commands/single-catalogs-unload-time.command.service';
import { FilterUnloadTimesCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/filter-unload-times.command';
import { SetDefaultUnloadTimeCommand } from '@ordersnproducts/modules/order-builder/modules/specification/services/commands/set-default-unload-time.command';
import { Features } from '@ordersnproducts/features';
import { Application } from '@ordersnproducts/modules/order-builder/modules/specification/constants/application';

export const rmsUL = {
  recipe: [
    {
      type: FormInputComponent,
      label: 'id',
      name: SpecFieldNames.ID,
      containerClassNames: ['d-none'],
      placeholder: 'id',
    } as FieldConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.product_description',
      name: SpecFieldNames.PRODUCT_SELECTION,
      dataTId: SpecFieldTestIds.PRODUCT_DESCRIPTION,
      containerClassNames: ['field-12x field-md-6x retail-control'],
      optionsLoader: MixReferencesOptionsLoaderOpenPlatformService,
      loading: ProductsDisablerOpenPlatformProvider.IsLoading,
      validation: [Validators.required],
      dynamicEffects: [ProductsOpenPlatformEffects, CutOffEffects],
      placeholder: 'views.specifications.select_product',
      onChange: [
        LoadContractMixReferenceService,
        LoadSingleCatalogsUnloadTypeMixRef,
        LoadSingleCatalogsSpacingMixRef,
        LoadSingleCatalogsUnloadTimeMixRef,
        LoadSingleCatalogsLoadSizeMixRef,
        LoadSingleCatalogsApplicationMixRef,
        ResetSlotOpenPlatformCommandService,
      ],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormInputNumberComponent,
      label: 'views.specifications.quantity',
      containerClassNames: ['field-11x field-md-2x retail-control'],
      name: SpecFieldNames.QUANTITY,
      dataTId: SpecFieldTestIds.QUANTITY,
      min: 1,
      value: 1,
      step: 0.5,
      max: 1000,
      suffix: UNITS.CUBIC_METERS,
      validation: [Validators.required, Validators.max(1000), Validators.min(1)],
      decimals: 1,
      onChange: [ResetSlotOpenPlatformCommandService],
      errorMessage: QuantityErrorOpenPlatformProvider.ErrorMessage,
    } as FieldInputNumberConfig,
    {
      type: FormInfoIconMessageComponent,
      name: SpecFieldNames.CONCRETE_MIN_QUANTITY_INFO,
      dataTId: SpecFieldTestIds.CONCRETE_MIN_QUANTITY_INFO,
      value: false,
      containerClassNames: ['field-1x field-md-1x retail-control'],
      text: CapacityProvider.MinMaxMessage,
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormInfoMessageComponent,
      name: SpecFieldNames.PRODUCT_PUMP_INFORMATIVE,
      dataTId: SpecFieldTestIds.PRODUCT_PUMP_INFORMATIVE,
      containerClassNames: ['field-12x field-md-6x'],
      text: 'views.specifications.pumping_not_available',
      hidden: PumpAvailability.ShouldHide,
    } as FieldLabelConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.contract',
      name: SpecFieldNames.CONTRACT_SELECT,
      dataTId: SpecFieldTestIds.CONTRACT_SELECT,
      containerClassNames: ['field-4x field-md-4x retail-control'],
      validation: [Validators.required],
      optionsLoader: ContractsOptionLoaderOpenPlatformService,
      placeholder: 'views.specifications.select_contract',
      onChange: [LoadPaymentTermOpenPlatformCommandService, ResetSlotOpenPlatformCommandService],
      rehydrate: true,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.paymentTerms',
      name: SpecFieldNames.PAYMENT_TERMS,
      dataTId: SpecFieldTestIds.PAYMENT_TERMS,
      containerClassNames: ['field-12x field-md-2x retail-control'],
      disabled: true,
      hidden: true,
      value: 'ZC05',
      optionsLoader: PaymentTermsContractOptionLoaderOpenPlatformService,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unload_type',
      name: SpecFieldNames.UNLOAD_TYPE,
      dataTId: SpecFieldTestIds.UNLOAD_TYPE,
      containerClassNames: ['field-12x field-md-2x retail-control'],
      placeholder: 'views.specifications.select_unloadType',
      optionsLoader: SingleUnloadTypesLoaderService,
      validation: [Validators.required],
      onChange: [FilterUnloadTimesCommand, SetDefaultUnloadTimeCommand],
      hasFeatureEnabled: Features.UNLOAD_TYPE_AND_APPLICATION_CATALOGUES_HOMOLOGATION,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unload_type',
      name: SpecFieldNames.UNLOAD_TYPE,
      dataTId: SpecFieldTestIds.UNLOAD_TYPE,
      containerClassNames: ['field-12x field-md-2x retail-control'],
      value: '30_MIN',
      optionsLoader: SingleUnloadTypesLoaderService,
      validation: [Validators.required],
      onChange: [FilterUnloadTimesCommand, SetDefaultUnloadTimeCommand],
      disabled: true,
      hidden: true,
      hasFeatureDisabled: Features.UNLOAD_TYPE_AND_APPLICATION_CATALOGUES_HOMOLOGATION,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.unloadTime',
      name: SpecFieldNames.DISCHARGE_TIME,
      dataTId: SpecFieldTestIds.UNLOAD_TIME,
      containerClassNames: ['field-12x field-md-2x retail-control'],
      placeholder: 'views.specifications.select_unloadTime',
      optionsLoader: FilteredUnloadTimesLoaderService,
      validation: [Validators.required],
      onChange: [SetUnloadTimeChangeCommand, ResetSlotOpenPlatformCommandService],
    } as FieldSelectConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: FormSelectComponent,
      label: 'views.specifications.spacing',
      name: SpecFieldNames.SPACING,
      dataTId: SpecFieldTestIds.SPACING,
      containerClassNames: ['field-12x field-md-2x retail-control'],
      placeholder: 'views.specifications.select_spacing',
      optionsLoader: SingleSpacingsLoaderUkService,
      validation: [Validators.required],
      dynamicEffects: [SingleCatalogsEffects],
      onChange: [ResetSlotOpenPlatformCommandService],
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.application',
      name: SpecFieldNames.APPLICATION,
      dataTId: SpecFieldTestIds.APPLICATION,
      optionsLoader: SingleApplicationsLoaderService,
      containerClassNames: ['field-12x field-md-2x retail-control'],
      placeholder: 'views.specifications.select_application',
      validation: [Validators.required],
      value: Application.Base,
      hasFeatureEnabled: Features.UNLOAD_TYPE_AND_APPLICATION_CATALOGUES_HOMOLOGATION,
    } as FieldSelectConfig,
    {
      type: FormSelectComponent,
      label: 'views.specifications.application',
      name: SpecFieldNames.APPLICATION,
      dataTId: SpecFieldTestIds.APPLICATION,
      optionsLoader: SingleApplicationsLoaderService,
      containerClassNames: ['field-12x field-md-2x retail-control'],
      placeholder: 'views.specifications.select_application',
      validation: [Validators.required],
      value: 'Base',
      disabled: true,
      hidden: true,
      hasFeatureDisabled: Features.UNLOAD_TYPE_AND_APPLICATION_CATALOGUES_HOMOLOGATION,
    } as FieldSelectConfig,
    {
      type: FormInputCheckboxComponent,
      name: SpecFieldNames.CLEAN_UP,
      dataTId: SpecFieldTestIds.CLEAN_UP,
      value: false,
      containerClassNames: ['field-6x field-md-2x retail-control specification-adjustment ml-sm-5 pt-sm-2'],
      placeholder: 'views.specifications.kicker_UK',
    } as FieldConfig,
    {
      type: FormInputComponent,
      label: SpecFieldNames.SCHEDULE_MOMENT,
      name: SpecFieldNames.SCHEDULE_MOMENT,
      dataTId: SpecFieldTestIds.SCHEDULE_MOMENT,
      placeholder: '',
      hidden: false,
      visible: false,
      validation: [Validators.required],
      disabled: DateTimeEnablerProvider.DisableScheduleMomentFormField,
    } as FieldConfig,
    {
      type: FormInputComponent,
      label: SpecFieldNames.WAITING_LIST_MOMENT,
      name: SpecFieldNames.WAITING_LIST_MOMENT,
      dataTId: SpecFieldTestIds.WAITING_LIST_MOMENT,
      placeholder: '',
      hidden: false,
      visible: false,
      disabled: DateTimeEnablerProvider.DisableScheduleMomentFormField,
    } as FieldConfig,
    {
      type: null,
      push: true,
    } as NewLineField,
    {
      type: null,
      push: true,
    } as NewLineField,
  ],
} as RmsFormConfig;
